import axios from "axios";
import { useContext, useEffect } from "react";
import { ViewerContext } from "../../Context/ViewerContext/ViewerContextProvider";
import { XktContext } from "../../Context/XktContext/XktContextProvider";

import { setTreeViewCache, setTreeviewObjects, setTreeviewRender } from "../../Context/ViewerContext/Reducer";

import { TreeViewCacheItem, TreeviewModel } from "../../Models/Treeview";
import { getConfig } from "../../_Configuration/configuration";

import TreeviewRenderer, { TreeRenderElement } from "./TreeviewRenderer";

const Treeview = () => {
    const { state } = useContext(XktContext);
    const { state: viewerState, dispatch } = useContext(ViewerContext);

    const loadModels = async () => {
        const objs: TreeviewModel[] = [];
        const newCache: TreeViewCacheItem[] = viewerState.treeViewCache;
        let cacheUpdated = false;
        const cdn = getConfig().cdn;
        for (const src of state.models) {
            const treeCache = src?.treeViewPath ?? `${src?.url ?? cdn}/${src.folder}/treeview.json`;
            const modelPath = src?.modelPath ?? `${src?.url ?? cdn}/${src.folder}/model.xkt`;
            const cacheItem = viewerState.treeViewCache.filter(
                (x) => (src?.modelPath ?? `${src?.url ?? cdn}/${x.src.folder}/model.xkt`) === modelPath
            );
            if (cacheItem.length === 0) {
                const modelResp = await axios.get(treeCache);
                const model = modelResp.data as TreeviewModel;
                if (modelResp.data.constructor != "".constructor) {
                    //if file not found vite returns a html file as string instead of a json
                    model.src = treeCache;
                    objs.push({
                        children: [model],
                        id: src.modelId,
                        type: "",
                        family: null,
                        name: src.modelName,
                        parent: null,
                        open: false,
                        src: treeCache,
                        rawSrc: modelPath,
                        modelId: src.modelId,
                    });
                    newCache.push({
                        src,
                        model,
                    });
                    cacheUpdated = true;
                }
            } else {
                objs.push({
                    children: [cacheItem[0].model],
                    id: src.modelId,
                    type: "",
                    family: null,
                    name: src.modelName,
                    parent: null,
                    open: false,
                    src: treeCache,
                    rawSrc: modelPath,
                    modelId: src.modelId,
                });
            }
        }

        if (cacheUpdated) {
            dispatch(setTreeViewCache(newCache));
        }
        dispatch(setTreeviewObjects(objs));
    };

    const convertToRenderModel = (
        root: string | null,
        models: TreeviewModel[],
        parent: string,
        depth: number = 0
    ): TreeRenderElement[] => {
        const renderModels: TreeRenderElement[] = [];
        for (const model of models) {
            const modelInObject = viewerState.treeviewRender.filter((x) => x.id == `${model.modelId}#${model.id}`);
            if (modelInObject.length > 0) {
                modelInObject[0].parent = parent;
                renderModels.push(modelInObject[0]);
                continue;
            }
            const rootId = root ?? model.modelId;
            const id = `${rootId}#${model.id}`;
            const renderModel: TreeRenderElement = {
                id,
                type: model.type,
                name: model.name != null && model.name !== "" ? model.name : model.id,
                parent: parent,
                depth,
                children: [],
                isExpanded: false,
            };
            if (model.children) {
                renderModel.children = convertToRenderModel(rootId, model.children, id, depth + 1);
            }
            renderModels.push(renderModel);
        }
        return renderModels;
    };

    useEffect(() => {
        loadModels();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.models]);

    useEffect(() => {
        dispatch(setTreeviewRender(convertToRenderModel(null, viewerState.treeviewObjects, "")));
    }, [viewerState.treeviewObjects]);

    return (
        <>
            <TreeviewRenderer
                data={viewerState.treeviewRender}
                setData={(data) => {
                    dispatch(setTreeviewRender(data));
                }}
            />
        </>
    );
};

export default Treeview;
